import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FormInput, FormNumericTextBox, FormTextArea } from '../FormComponents'
import { Accrual, PostAccrual, UpdateAccrual } from '../../../data/interfaces'

interface AccrualFormProps {
  accrual: Accrual | null
  jobId: number
  onSubmit: (accrual: PostAccrual | UpdateAccrual) => void
  onCancel: () => void
}

const AccrualForm = (props: AccrualFormProps) => {
  const [formData, setFormData] = useState({
    description: '',
    value: 0,
  })

  useEffect(() => {
    if (props.accrual) {
      setFormData({
        description: props.accrual.description,
        value: props.accrual.value,
      })
    } else {
      setFormData({
        description: '',
        value: 0,
      })
    }
  }, [props.accrual])

  const handleSubmit = () => {
    if (props.accrual) {
      // Update existing accrual
      const updateData: UpdateAccrual = {
        accrualId: props.accrual.accrualId,
        jobId: props.jobId,
        description: formData.description,
        value: formData.value,
      }
      props.onSubmit(updateData)
    } else {
      // Create new accrual
      const postData: PostAccrual = {
        jobId: props.jobId,
        description: formData.description,
        value: formData.value,
      }
      props.onSubmit(postData)
    }
  }

  const requiredValidator = (value: any) => {
    return value ? '' : 'This field is required'
  }

  const valueValidator = (value: number) => {
    if (!value && value !== 0) {
      return 'Value is required'
    }
    if (value > 9999999999.99) {
      return 'Value cannot exceed 9999999999.99'
    }
    return ''
  }

  return (
    <div style={{ padding: '20px' }}>
      <Form
        key={props.accrual?.accrualId || 'new'}
        onSubmit={handleSubmit}
        initialValues={{
          description: props.accrual?.description || '',
          value: props.accrual?.value || 0,
        }}
        render={(formRenderProps) => (
          <FormElement style={{ width: '100%' }}>
            <fieldset className={'k-form-fieldset'}>
              <Field
                name={'description'}
                component={FormTextArea}
                label={'Description:'}
                placeholder={'Enter accrual description'}
                validator={requiredValidator}
                onChange={(e) => {
                  setFormData({ ...formData, description: e.value })
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <p style={{ margin: '0 1em 0 0', top: '20px', position: 'relative' }}><b>£</b></p>
                <Field
                  name={'value'}
                  component={FormNumericTextBox}
                  label={'Value:'}
                  placeholder={'Enter accrual value'}
                  validator={valueValidator}
                  format="n2"
                  min={0}
                  max={9999999999.99}
                  step={0.01}
                  onChange={(e) => {
                    setFormData({ ...formData, value: e.value })
                  }}
                />
              </div>

              <div className='button__container' style={{ marginTop: '20px' }}>
                <button
                  type="submit"
                  className='form__edit__button accept'
                  disabled={!formData.description || !formData.value}
                >
                  {props.accrual ? 'Update Accrual' : 'Add Accrual'}
                </button>
                <button
                  type="button"
                  className='form__edit__button reject'
                  onClick={props.onCancel}
                >
                  Cancel
                </button>
              </div>
            </fieldset>
          </FormElement>
        )}
      />
    </div>
  )
}

export default AccrualForm
